<template>
  <div class="sectionNews" id="news" ref="newsRef">
    <div class="top">
      <span class="title"> {{ $t('news') }} </span>
      <div class="nav-pagination"></div>
    </div>
    <Swiper :pagination="swiperConfig" :threshold="10" @swiper="setSwiperRef" class="news-swiper">
      <SwiperSlide class="main" v-for="(type, index) in articleTypeList" :key="index">
        <NewsContent :type="type"></NewsContent>
      </SwiperSlide>
    </Swiper>
    <a href="#list" class="more">{{ $t('moreNews') }}</a>
  </div>
</template>

<script setup lang="ts">
import newsHook from '@/hooks/newsHook';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { articleTypeList } from "@/hooks/commonArticleHook";
import SwiperCore, { Pagination } from 'swiper';
import NewsContent from '@/components/news/NewsContent.vue';
SwiperCore.use([Pagination]);
const {swiperConfig, newsRef, swiperRef } = newsHook();
const setSwiperRef = (swiper) => {
  swiperRef.value = swiper
}
</script>
